import React from 'react';
import { List, ListItem, ListItemIcon, ListItemText } from '@material-ui/core';
import EditIcon from '@material-ui/icons/EditOutlined';
import DeleteIcon from '@material-ui/icons/DeleteOutline';
import BottomSheet from '../organisim/bottom-sheet';
import { colors } from '../../config/theme';

const PostActionsSheet = ({ open, onClose, onEdit, onDelete }) => {
  return (
    <BottomSheet open={open} onClose={onClose} title="Post options">
      <List disablePadding>
        <ListItem button onClick={onEdit}>
          <ListItemIcon>
            <EditIcon style={{ color: colors.textPrimary }} />
          </ListItemIcon>
          <ListItemText primary="Edit post" />
        </ListItem>
        <ListItem button onClick={onDelete}>
          <ListItemIcon>
            <DeleteIcon style={{ color: colors.dangerBright }} />
          </ListItemIcon>
          <ListItemText
            primary="Delete post"
            primaryTypographyProps={{ style: { color: colors.dangerBright } }}
          />
        </ListItem>
      </List>
    </BottomSheet>
  );
};

export default PostActionsSheet;
